/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import LeftContainerList from './leftContainerList';
import MegamenuCreation from './MegamenuCreation';
import CollapseRightArrow from './collapseRightarrow';
import happayLogo from '../../assets/images/IPP_product_logo_2.svg';
import happayLogoSmall from '../../assets/images/IPP_product_logo_small.svg';
import { RouteConfig } from '../../constants/routeConfigMap';
import history from '../../utils/history';

export default class NavBar extends React.Component {
  render() {
    const { isCollapsed, changeCollapse, userInfo } = this.props;
    const bigScreen = window.screen.width > 1024;
    let isAdmin = false;
    if (userInfo && userInfo.has_role) {
      isAdmin = true;
    }
    // const isDashboard = cookieLib.getCookieByKey('view_type') === 'dashboard'
    return (
      <Grid container item xs={24} className="left-navigation-bar">
        <div className="primary-navigation-bar padding-t-20 padding-b-20">
          {isCollapsed ? (
            <div className="padding-l-20 margin-b-16">
              <img
                src={happayLogoSmall}
                onClick={() => history.push('/dashboard')}
                style={{
                  height: '34px',
                  cursor: 'pointer',
                }}
                alt="happay logo"
              />
            </div>
          ) : (
            <img
              src={happayLogo}
              onClick={() => history.push('/dashboard')}
              className="padding-l-20"
              style={{
                height: '50px',
                cursor: 'pointer',
              }}
              alt="happay logo"
            />
          )}
          {
            // cookieLib.getCookieByKey('view_type') === 'dashboard' ?
            // <MegamenuCreation
            //   getContainerDraftId={() => {}}
            //   isCollapsed={isCollapsed}
            //   megaMenuList={
            //     isAdmin
            //       ? [
            //         { name: '+ New user', key: 'newUser' },
            //         { name: '+ New card', key: 'newCard' },
            //         { name: 'Request card', key: 'requestCard' },
            //         { name: 'Pay bill', key: 'payBill' },
            //       ]
            //       : [{ name: 'Request card', key: 'requestCard' }]
            //   }
            // />
            // : null
          }
          <LeftContainerList
            containerList={RouteConfig}
            isCollapsed={isCollapsed}
            // onMouseOver={bigScreen ? this.props.changeCollapse : null}
            // onMouseLeave={() => {}}
            // isDashboardView={isDashboard}
            historyChange={history.location.pathname}
            userinfo={this.props.userInfo}
          />
          {bigScreen && (
            <CollapseRightArrow
              isOpen={isCollapsed}
              handleToggle={changeCollapse}
              // onMouseOver={() => {}}
              // onMouseLeave={() => {}}
            />
          )}
        </div>
      </Grid>
    );
  }
}

NavBar.propTypes = {
  changeCollapse: PropTypes.func,
  userInfo: PropTypes.object,
  isCollapsed: PropTypes.bool,
};

NavBar.defaultProps = {
  changeCollapse: () => {},
};
